import { IROUTE_PATHS } from './@types';

const ROUTE_PATHS: IROUTE_PATHS = {
  ROOT: '/',
  SIGN_UP: '/sign-up',
  OB: '/ob',
  PAYWALL: '/paywall',
  PAYWALL_PAYMENT: '/payment',
  DOWNLOAD: '/download',
  FROM_QUIZ: '/from-quiz',
  LANDING: '/landing',
  PP: '/pp',
  WELCOME_TO_CHAT: '/welcome-to-chat',
  CHAT: '/chat',
  CHAT_SIGN_UP: '/chat-sign-up',
};

export default ROUTE_PATHS;
